import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const createSomeControlInGroupSatisfiesConditionValidator = (
  conditionToSatisfy: (controlName: string, control: AbstractControl) => boolean,
  noneSatisfiesErrorKey?: string
): ValidatorFn => {
  const someControlInGroupSatisfiesConditionValidator: ValidatorFn = (formGroup: FormGroup) => {
    const controlNames = Object.getOwnPropertyNames(formGroup.controls);
    for (const controlName of controlNames) {
      if (conditionToSatisfy(controlName, formGroup.controls[controlName])) {
        return null;
      }
    }
    const error: ValidationErrors = {};
    error[noneSatisfiesErrorKey || 'noneSatisfiedCondition'] = true;
    return error;
  };
  return someControlInGroupSatisfiesConditionValidator;
};
